import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Pipeline() {
  const { t } = useLang();
  const c = t.pipeline;
  return (
    <section id="pipeline" data-testid="pipeline-section" className="py-24 sm:py-32 border-t border-border bg-ivory-pure">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-olive-soft leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
          {c.items.map((it, i) => (
            <Reveal key={i} delay={i * 70} data-testid={`pipeline-item-${i}`} className="bg-ivory p-8 sm:p-10 flex flex-col gap-5">
              <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta">{it.tag}</div>
              <h3 className="font-display text-2xl sm:text-3xl text-olive leading-tight">{it.title}</h3>
              <p className="text-olive-soft leading-relaxed">{it.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
